import { render, staticRenderFns } from "./NetaMultiAttractionDetailsMenuComponent.vue?vue&type=template&id=8dc67758&scoped=true&"
import script from "./NetaMultiAttractionDetailsMenuComponent.vue?vue&type=script&lang=js&"
export * from "./NetaMultiAttractionDetailsMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaMultiAttractionDetailsMenuComponent.vue?vue&type=style&index=0&id=8dc67758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc67758",
  null
  
)

export default component.exports